import { createContext } from 'react'
import { CartItem, CartItemSet, CartItemSlot, UpgradeItemSet } from '../../hooks'


interface Props {
  addItem?: (slot: CartItemSlot) => void
  addCartItem?: (slot: CartItemSlot, item: CartItem) => void
  clear?: () => void
  items?: CartItem[]
  msrp?: number
  refresh?: () => void
  removeItem?: (slot: CartItemSlot) => void
  savingsPercent?: number
  total?: number
  getItemSet?: () => CartItemSet
  getItemsBySlot?: (slot: CartItemSlot) => CartItem | undefined
  updateItemSet?: (itemSet: CartItemSet) => void
  updateShipping?: (country?: string) => void
  upgrades?: UpgradeItemSet[]
  subtotal?: number
}

export const CartContext = createContext<Props>({})


